import DocumentTemplateTag from '@/models/DocumentTemplateTag';

const GET_DOCUMENT_TEMPLATES_TAGS = 'get_document_template_tags';
const GET_DOCUMENT_TEMPLATES_TAGS_REQUEST = GET_DOCUMENT_TEMPLATES_TAGS + '_request';
const GET_DOCUMENT_TEMPLATES_TAGS_SUCCESS = GET_DOCUMENT_TEMPLATES_TAGS + '_success';
const GET_DOCUMENT_TEMPLATES_TAGS_ERROR = GET_DOCUMENT_TEMPLATES_TAGS + '_error';

export { GET_DOCUMENT_TEMPLATES_TAGS };

export const DOCUMENT_TEMPLATE_TAG_TYPE_STRING = 'text_singleline';
export const DOCUMENT_TEMPLATE_TAG_TYPE_CHOICE = 'list';

export default {
    state: {
        tags: [],
        loading: false,
        tags_errors: [],
    },
    mutations: {
        [GET_DOCUMENT_TEMPLATES_TAGS_REQUEST]: (state) => {
            state.tags = [];
            state.loading = true;
            state.tags_errors = [];
        },
        [GET_DOCUMENT_TEMPLATES_TAGS_SUCCESS]: (state, { tags }) => {
            state.tags = tags;
            state.loading = false;
            state.tags_errors = [];
        },
        [GET_DOCUMENT_TEMPLATES_TAGS_ERROR]: (state, { errors }) => {
            state.tags = [];
            state.loading = false;
            state.tags_errors = errors;
        },
    },
    actions: {
        [GET_DOCUMENT_TEMPLATES_TAGS]: ({ commit, rootState }, { scope = 'trajectory', params = {} }) => {
            commit(GET_DOCUMENT_TEMPLATES_TAGS_REQUEST);
            return new Promise((resolve, reject) => {
                const Tags = DocumentTemplateTag.makeModel(`/document-templates/${scope}/tags`);
                Tags.collection(params)
                    .then(({items, meta}) => {
                        const tags = items;
                        commit(GET_DOCUMENT_TEMPLATES_TAGS_SUCCESS, { tags });
                        resolve(tags);
                    })
                    .catch(({ status, errors }) => {
                        commit(GET_DOCUMENT_TEMPLATES_TAGS_ERROR, { errors });
                        reject({ status, errors });
                    });
            });
        },
    },
    getters: {}
};



// WEBPACK FOOTER //
// ./src/store/modules/document-template-tags.js